import React from "react";

const ToolbarLeft = ({ children }) => {
    return (
        <div className="card-tools">
            {children}
        </div>
    )
}

export default ToolbarLeft;